import { Button, Col, Modal, Row, Table } from 'react-bootstrap';
import { MdModeEdit, MdDelete } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import { showModal } from '../../../store/slices/modal/modalSlice';
import { IMAGE_BASE_URL } from '../../../config';
import { useMemo, useState } from 'react';
import style from './FoodItemTable.module.css';
import { deleteFoodItemById } from '../../../store/slices/foodItems/foodItemsThunk';
import { useTranslation } from 'react-i18next';
import { FoodItemCard } from './food Item card/FoodItemCard';
import { EmptyTableMessage } from '../../../sections/components/EmptyTableMessage';

export function FoodItemTable({ fetchFoodItem, editFoodItem, search }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const foodItem = useSelector((state) => state.foodItems);
  const category = useSelector((state) => state.category);
  const { currentLanguage } = useSelector((state) => state.language);
  const [previewImage, setPreviewImage] = useState(null);
  const handleClosePreview = () => setPreviewImage(null);

  const filteredFoods = useMemo(() => {
    if (!search) return foodItem.foodItems;
    return foodItem.foodItems.filter((item) => {
      const translation = item.translationsMap?.[currentLanguage] || item.translationsMap?.['en'] || {};
      return translation.name.toLowerCase().includes(search.toLowerCase())});
  }, [foodItem.foodItems, search]);

  const onDelete = (id) => {
    dispatch(
      showModal({
        title: t('menu_management.food.deleteFoodItem'),
        message: t('menu_management.food.sureWantToDelete'),
        type: 'confirm',
        onConfirm: () => deleteFoodItem(id)
      })
    );
  };

  const deleteFoodItem = (id) => {
    dispatch(deleteFoodItemById(id))
      .unwrap()
      .then(() => {
        // Logic only for what happens AFTER success
        fetchFoodItem();
      })
      .catch(() => {
        // You don't even need to do anything here anymore!
        // The middleware handles the toast and logs.
      });
  };

  const onEdit = (item) => {
    editFoodItem(item);
  };

  return (
    <>
      <Row>
        {Array.isArray(filteredFoods) &&
          filteredFoods.map((item, index) => {
            return (
              <Col xl={3} md={6} xs={12}>
                <FoodItemCard
                  key={index}
                  item={item}
                  currentLanguage={currentLanguage}
                  categoryDetails={category.categoryDetails}
                  onDelete={onDelete}
                  onEdit={onEdit}
                />
              </Col>
            );
          })}
          {Array.isArray(filteredFoods) && filteredFoods.length === 0 && <Col md={12}>
            <div className='w-100 text-center d-flex justify-content-center'>
              <EmptyTableMessage colSpan={4} message="No Food items found" />
            </div>
          </Col>}
      </Row>
      <Modal show={!!previewImage} onHide={handleClosePreview} centered size="lg" contentClassName={style.imagePreviewModal}>
        <Modal.Header closeButton closeVariant="white" className="border-0 bg-transparent" />
        <Modal.Body className="p-0 text-center">
          <img
            src={previewImage}
            alt="Full Size Food"
            className="img-fluid rounded shadow-lg"
            style={{ maxHeight: '80vh', objectFit: 'contain' }}
          />
        </Modal.Body>
      </Modal>
    </>
  );
}
// {item.image ? (
//                       <div className={style.tableImageWrapper} onClick={() => setPreviewImage(`${IMAGE_BASE_URL}${item.image}`)}>
//                         <img src={`${IMAGE_BASE_URL}${item.image}`} alt={translation.name} className={style.tableImageThumbnail} />
//                         <div className={style.imageOverlay}>
//                           <small>View</small>
//                         </div>
//                       </div>
//                     ) : (
//                       <div className={style.noImagePlaceholder}>
//                         <small className="text-muted">N/A</small>
//                       </div>
//                     )}
